import 'bootstrap';

import('../app.ts');

// fix scrolling after lazy-loaded elements
import('./scrollToHash.ts');
